import { useSelector } from "react-redux";
import ChangeImage from "../component/HeaderImage";
import AccessDenied from "../component/AccessDenied";
import { isTaskAllowed } from "../utils/isTaskAllowed";

const HeaderImage = () => {
    const { admin } = useSelector((state) => state.auth);

    if(admin?.email !== "admin@thriftyx.com" &&
        !isTaskAllowed("Header Image", admin?.assignedWork)) return (<AccessDenied />)

    return ( <ChangeImage /> )
}
export default HeaderImage;
